module.exports = __webpack_public_path__ + "static/img/4.48e3941.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/4/eng/4.png
// module id = xlYh
// module chunks = 0